import styled from 'styled-components'

import { Container as Card } from '../../../components/Card/styles'
import bgImage from '../../../assets/images/login-bg.jpg'

export const Container = styled.div`
	padding: 10vh;
	width: 100%;
	display: flex;
	justify-content: center;
	background-image: url(${bgImage});
	background-position: bottom;
	background-size: cover;
	background-repeat: no-repeat;

	@media(max-width: 600px) {
		padding: 4vh 0;
	}
`

export const Content = styled(Card).attrs({
	className: 'no-responsive'
})`
	width: 100%;
	max-width: 315px;
	text-align: center;

	img {
		width: 80px;
	}

	form {
		display: flex;
		flex-direction: column;

		h1 {
			font-size: 18px;
			margin: 16px 8px 10px;
			font-weight: 500;
		}

		p {
			padding: 15px;
		}

		a {
			font-size: 14px;
		}

		button {
			margin: 15px 8px 0 !important;
		}
	}
`
